var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.definitions)?_c('div',{staticClass:"dashboard"},[_c('sections',_vm._b({},'sections',{sections: _vm.sections},false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }